export { default } from "./Switch.mjs";
export { default as switchClasses } from "./switchClasses.mjs";
export * from "./switchClasses.mjs";